import React from 'react';
import {connect} from 'react-redux';

import mapDispatch from '~/misc/mapDispatch';

import css from './index.css';

class DotHit extends React.Component {
  constructor() {
    super();
    this.state = {
      flag: false,
    };
    this.showMessage = this.showMessage.bind(this);
  }

  render() {
    const children = (
      <div className={css.toolTipWrap}>
        <span>{this.props.dots.question}</span><br/>
        <span>{this.props.dots.answer}</span>
      </div>);

    return (
      <div className={css.message}>
        <div className={css.parent} onMouseEnter={() => this.showMessage()} onMouseLeave={() => this.showMessage()}>
        ?
        </div>
        <div>{ this.state.flag && children }</div>
      </div>);
  }

  showMessage() {
    let bool = this.state.flag;
    this.setState({flag: !bool});
  }
}

export default connect((state) => ({
  dots: state.dots.data.dot_window,
}), mapDispatch({})
)(DotHit);



// WEBPACK FOOTER //
// ./src/components/common/DotMessage/index.js